export const memberQueryKeys = {
    all: (agentId: number) => ["member", "agent", agentId]
} as const;
